import React, { Component } from "react";
import { Form, Row, Col } from 'react-bootstrap';

import { Button, Card, CardContent, TextField, Box, Typography, Paper } from '@mui/material';
import { Lock, Warning, Save } from '@mui/icons-material';

import CookieManager from "../managers/CookieManager";
import LocalStorageManager from "../managers/LocalStorageManager";
import Events from '../service/Events';

import ClientAPI from "../service/ClientAPI";

class Account extends Component {

    onUpdatePassword = (ev) => {
        const _inputs = ev.target,
            _password = _inputs.password.value,
            _rpassword = _inputs.rpassword.value,
            _cpassword = _inputs.cpassword.value;

        if (!_cpassword || !_password || !_rpassword || _password !== _rpassword) {
            Events.onResult.emit("error", "Passwörter stimmen nicht überein");

            ev.preventDefault();
            return;
        }

        ClientAPI.UpdatePassword({ cpassword: _cpassword, rpassword: _rpassword, password: _password })
            .then((_res) => {
                CookieManager.Save("auth", _res.token);
                LocalStorageManager.Save("admin", _res.isAdmin);

                if (LocalStorageManager.Get("isSaved")) {
                    LocalStorageManager.SaveMultiple([
                        { key: "password", value: _password },
                        { key: "email", value: _res.email }
                    ]);
                }

                Events.onResult.emit("success", "Passwort wurde aktualisiert!");
            })

        ev.preventDefault();
    }

    deleteAccount = () => {
        Events.onAlert.emit("warning", "Account Löschung", "Wenn Sie Ihren Account löschen werden alle Ihre Bestellungen und Login - Daten gelöscht, sind Sie sich sicher?"
            , () => {
                ClientAPI.DeleteAccount()
                    .then(() => {
                        CookieManager.Delete("auth");
                        LocalStorageManager.DeleteMultiple(["admin", "password", "email", "isSaved"]);

                        window.location.replace("/");
                    })
            });
    }

    render() {
        return (
            <div style={{ 
                maxWidth: window.innerWidth < 600 ? "95%" : "80%", 
                margin: "auto", 
                marginTop: window.innerWidth < 600 ? "20px" : "40px", 
                paddingBottom: window.innerWidth < 600 ? "40px" : "60px" 
            }}>
                <Typography 
                    variant="h3" 
                    sx={{ 
                        textAlign: "center", 
                        mb: { xs: 3, sm: 4 },
                        fontWeight: 700,
                        color: "#2e7d32",
                        fontSize: { xs: '1.75rem', sm: '2.5rem', md: '3rem' }
                    }}
                >
                    Account Einstellungen
                </Typography>

                <Paper
                    elevation={3}
                    sx={{
                        maxWidth: "600px",
                        margin: "auto",
                        borderRadius: { xs: '12px', sm: '20px' },
                        overflow: 'hidden',
                        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)"
                    }}
                >
                    {/* Header with gradient */}
                    <Box
                        sx={{
                            background: 'linear-gradient(135deg, #2e7d32 0%, #66bb6a 100%)',
                            p: { xs: 2, sm: 3 },
                            color: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            gap: { xs: 1.5, sm: 2 }
                        }}
                    >
                        <Lock sx={{ fontSize: { xs: '1.5rem', sm: '2rem' } }} />
                        <Typography variant="h5" sx={{ fontWeight: 600, fontSize: { xs: '1.1rem', sm: '1.5rem' } }}>
                            Passwort ändern
                        </Typography>
                    </Box>

                    <CardContent sx={{ p: { xs: 2.5, sm: 4 } }}>
                        <Form onSubmit={this.onUpdatePassword}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                                <Form.Group as={Col} controlId="formGridCurrentPassword">
                                    <Form.Label style={{ fontWeight: 600, color: '#333', marginBottom: '8px' }}>
                                        Derzeitiges Passwort
                                    </Form.Label>
                                    <Form.Control 
                                        name="cpassword" 
                                        type="password" 
                                        placeholder="Aktuelles Passwort eingeben"
                                        style={{
                                            borderRadius: '10px',
                                            padding: '12px',
                                            border: '2px solid #e0e0e0',
                                            fontSize: '1rem'
                                        }}
                                    />
                                </Form.Group>

                                <Form.Group as={Col} controlId="formGridPassword">
                                    <Form.Label style={{ fontWeight: 600, color: '#333', marginBottom: '8px' }}>
                                        Neues Passwort
                                    </Form.Label>
                                    <Form.Control 
                                        name="password" 
                                        type="password" 
                                        placeholder="Neues Passwort eingeben"
                                        style={{
                                            borderRadius: '10px',
                                            padding: '12px',
                                            border: '2px solid #e0e0e0',
                                            fontSize: '1rem'
                                        }}
                                    />
                                </Form.Group>

                                <Form.Group as={Col} controlId="formGridRepeatPassword">
                                    <Form.Label style={{ fontWeight: 600, color: '#333', marginBottom: '8px' }}>
                                        Passwort wiederholen
                                    </Form.Label>
                                    <Form.Control 
                                        name="rpassword" 
                                        type="password" 
                                        placeholder="Neues Passwort bestätigen"
                                        style={{
                                            borderRadius: '10px',
                                            padding: '12px',
                                            border: '2px solid #e0e0e0',
                                            fontSize: '1rem'
                                        }}
                                    />
                                </Form.Group>

                                <Button 
                                    type="submit" 
                                    variant="contained"
                                    startIcon={<Save />}
                                    fullWidth
                                    sx={{
                                        bgcolor: '#2e7d32',
                                        color: 'white',
                                        fontWeight: 600,
                                        textTransform: 'none',
                                        fontSize: { xs: '0.95rem', sm: '1.1rem' },
                                        py: { xs: 1.3, sm: 1.5 },
                                        borderRadius: '10px',
                                        mt: 2,
                                        boxShadow: '0 4px 12px rgba(46, 125, 50, 0.3)',
                                        '&:hover': {
                                            bgcolor: '#1b5e20',
                                            boxShadow: '0 6px 16px rgba(46, 125, 50, 0.4)',
                                            transform: 'translateY(-2px)'
                                        },
                                        transition: 'all 0.2s ease'
                                    }}
                                >
                                    Passwort aktualisieren
                                </Button>
                            </Box>
                        </Form>
                    </CardContent>
                </Paper>

                <Box sx={{ display: "flex", justifyContent: "center", mt: { xs: 3, sm: 4 } }}>
                    <Button 
                        onClick={this.deleteAccount} 
                        variant="contained" 
                        color="error"
                        startIcon={<Warning />}
                        fullWidth={window.innerWidth < 600}
                        sx={{
                            fontWeight: 600,
                            textTransform: 'none',
                            fontSize: { xs: '0.9rem', sm: '1rem' },
                            py: { xs: 1.3, sm: 1.5 },
                            px: { xs: 2, sm: 4 },
                            borderRadius: '10px',
                            maxWidth: { xs: '100%', sm: 'auto' },
                            boxShadow: '0 4px 12px rgba(211, 47, 47, 0.3)',
                            '&:hover': {
                                boxShadow: '0 6px 16px rgba(211, 47, 47, 0.4)',
                                transform: 'translateY(-2px)'
                            },
                            transition: 'all 0.2s ease'
                        }}
                    >
                        Account löschen
                    </Button>
                </Box>
            </div>
        );
    }
}

export default Account;